import { FeatureCard, FeaturesContent } from './types';

export const css = `
  .feature-section {
    .feature-card {
       background: linear-gradient(135deg, var(--c-secondary-0), color-mix(in oklch, var(--c-secondary-1) 80%, transparent));
       transition: transform 0.3s ease, box-shadow 0.3s ease;
       position: relative;
       overflow: hidden;
    }

    .feature-card::after {
       content: '';
       position: absolute;
       bottom: 0;
       left: 0;
       width: 100%;
       height: 4px;
       background: linear-gradient(90deg, var(--c-primary-3), var(--c-accent-3));
       transform: scaleX(0);
       transform-origin: left;
       transition: transform 0.3s ease;
    }

    .feature-card:hover::after {
       transform: scaleX(1);
    }

    .feature-icon {
       background: var(--c-secondary-1);
    }
  }
`;

function FeatureCard({ data }: { data: FeatureCard }) {
  return (
    <div class="feature-card rounded-xl p-10 shadow-xl hover:shadow-2xl hover:-translate-y-2 scale-100 transition-all">
      <div class="feature-icon size-20 rounded-full flex items-center justify-center mb-7 text-2xl">
        {data.icon}
      </div>
      <h3 class="feature-title text-2xl font-bold mb-5">{data.title}</h3>
      <p class="feature-description mb-6 leading-relaxed opacity-90">{data.description}</p>
      <a
        href={data.link.href}
        class="feature-link inline-flex items-center font-medium group text-inherit"
      >
        {data.link.text}
        <span class="ml-2 transition-transform duration-300 group-hover:translate-x-1.5">→</span>
      </a>
    </div>
  );
}

export function View({ data }: { data: FeaturesContent }) {
  return (
    <section id="services" class="feature-section py-24">
      <div class="max-w-7xl mx-auto px-8">
        <div class="text-center mb-16">
          <h2 class="feature-title text-4xl font-bold mb-5">{data.heading.title}</h2>
          <p class="feature-description max-w-2xl mx-auto opacity-80">{data.heading.subtitle}</p>
        </div>

        <div class="grid md:grid-cols-3 gap-12">
          {data.features.map((feature) => (
            <FeatureCard key={feature.id} data={feature} />
          ))}
        </div>
      </div>
    </section>
  );
}
